"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("../../utils");
require("./SelectInput.less");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var Option = _select.default.Option;
var SelectInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var placeholder = props.placeholder,
    size = props.size,
    showArrow = props.showArrow,
    loading = props.loading,
    onDropdownVisibleChange = props.onDropdownVisibleChange,
    options = props.options,
    onChange = props.onChange,
    value = props.value,
    showSearch = props.showSearch,
    name = props.name,
    suffixIcon = props.suffixIcon,
    dropdownClassName = props.dropdownClassName,
    dropdownMatchSelectWidth = props.dropdownMatchSelectWidth,
    showLabel = props.showLabel,
    disabled = props.disabled;
  if (!options && (0, _utils.isMobileOrTablet)()) {
    return null;
  }
  var areValuesNumbers = options[0] && !isNaN(options[0].value);
  var onChangeCombined = function onChangeCombined(e) {
    // Getting value for native vs antd
    // Native: e.target.value = 1, e.target.value = 2;
    // antd: e = 1, e = 2, etc.
    //
    // Also, the native <select> <option> converts all values into strings
    // (the type is DOMString: https://developer.mozilla.org/en-US/docs/Web/API/HTMLOptionElement)
    // We'll convert to Number before submitting it.
    var eValue = (0, _utils.isMobileOrTablet)() ? e.target.value : e;
    var newValue = areValuesNumbers ? Number(eValue) : eValue;
    if (onChange) {
      onChange(newValue);
    }
  };
  var searchableSelectProps = showSearch ? _utils.SEARCHABLE_SELECT_PROPS : {};
  var hasValue = !!value;
  if ((0, _utils.isMobileOrTablet)() && !hasValue) {
    options.unshift({
      value: 'none',
      label: placeholder,
      key: 'none'
    });
  }
  return (0, _utils.isMobileOrTablet)() ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, showLabel && /*#__PURE__*/_react.default.createElement("label", {
    className: "floating-label native-mobile-label"
  }, placeholder), /*#__PURE__*/_react.default.createElement("select", {
    onChange: onChangeCombined,
    disabled: disabled,
    name: name,
    className: "native-mobile-select"
  }, options.map(function (item, index) {
    if (index === 0 && !hasValue) {
      return /*#__PURE__*/_react.default.createElement("option", {
        selected: true,
        disabled: true,
        hidden: true,
        value: item.value
      }, item.label);
    }
    return /*#__PURE__*/_react.default.createElement("option", {
      value: item.value,
      selected: item.value === value
    }, item.label);
  }))) : /*#__PURE__*/_react.default.createElement(_select.default, _extends({
    placeholder: placeholder,
    size: size,
    showArrow: showArrow,
    loading: loading,
    onChange: onChangeCombined,
    onDropdownVisibleChange: onDropdownVisibleChange,
    ref: ref,
    value: value
  }, searchableSelectProps, {
    name: name,
    suffixIcon: suffixIcon,
    dropdownClassName: dropdownClassName,
    dropdownMatchSelectWidth: dropdownMatchSelectWidth,
    disabled: disabled
  }), options && options.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: item.key,
      value: item.value
    }, item.label);
  }));
});
SelectInput.propTypes = {
  placeholder: _propTypes.default.string.isRequired,
  size: _propTypes.default.string,
  showArrow: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  onDropdownVisibleChange: _propTypes.default.func,
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.any.isRequired,
    value: _propTypes.default.any.isRequired,
    label: _propTypes.default.string.isRequired
  })).isRequired,
  onChange: _propTypes.default.func,
  value: _propTypes.default.any,
  showSearch: _propTypes.default.bool,
  name: _propTypes.default.string,
  suffixIcon: _propTypes.default.element,
  dropdownClassName: _propTypes.default.string,
  dropdownMatchSelectWidth: _propTypes.default.bool,
  showLabel: _propTypes.default.bool,
  disabled: _propTypes.default.bool
};
var _default = SelectInput;
exports.default = _default;